import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { diasDeSemanaUtil } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import {
  saveEntHorDiasAction,
  setActivoEntHorDiasAction,
} from '../EntHorDiasAction';

const FormEntHorDias = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  const entHorDiasStore = Redux.useSelector((state) => state.entHorDias);

  const activo = isDelete ? null : entHorDiasStore.activo;

  const initData = {
    dia: '',
    num: 1,
    abrev: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    dia: false,
    num: false,
    abrev: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [isDisabled, setIsDisabled] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    setTimeout(
      () =>
        setData({
          dia: activo.dia,
          num: activo.num,
          abrev: activo.abrev,
        }),
      300,
    );
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      const res = await saveEntHorDiasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntHorarioClase: entHorariosClasesStore.activo.id,
        },
        entHorDiasStore.params,
      );
      if (res) {
        setActivoEntHorDiasAction(dispatch, null);
        setData(initData);
        setIsDisabled(false);
      }
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={12} align="center">
          {diasDeSemanaUtil.map((el) => {
            const exist = entHorDiasStore.all.some((it) => it.dia === el.dia);
            return (
              <BotonComponent
                key={`dias-${el.resourceId}`}
                variant={data.dia === el.dia ? 'contained' : 'outlined'}
                disabled={exist}
                click={() => {
                  if (exist) return;
                  setData({
                    dia: el.dia,
                    num: el.resourceId === 0 ? '0' : el.resourceId,
                    abrev: el.abrev,
                  });
                  setIsDisabled(true);
                }}
                text={el.dia}
                ml={1}
                mb={1}
                blue={data.dia === el.dia}
              />
            );
          })}
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.dia.name}
            required
            label={CONST.dia.label}
            value={data.dia}
            disabled={isDisabled}
            onChange={(e) =>
              _handleSetDataField(CONST.dia.name, e.target.value)
            }
            helperText={dataError.dia ? validMessage.required : null}
            error={dataError.dia}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            type="number"
            required
            label={CONST.num.label}
            disabled={isDisabled}
            value={Number(data.num)}
            onChange={(e) =>
              _handleSetDataField(CONST.num.name, e.target.value)
            }
            id={CONST.num.name}
            InputProps={{
              inputProps: { min: 0, max: 6 },
            }}
            helperText="0: Domingo"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.abrev.name}
            required
            label={CONST.abrev.label}
            disabled={isDisabled}
            value={data.abrev}
            onChange={(e) =>
              _handleSetDataField(CONST.abrev.name, e.target.value)
            }
            helperText={dataError.abrev ? validMessage.required : null}
            error={dataError.abrev}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
            mr={2}
          />
          {isDisabled && (
            <BotonComponent
              click={() => {
                setData(initData);
                setIsDisabled(false);
              }}
              text="LIMPIAR"
              red
              deleteIcon
              mr={2}
            />
          )}
          {entHorDiasStore.activo && !isDelete && (
            <BotonComponent
              click={() => {
                setActivoEntHorDiasAction(dispatch, null);
                setData(initData);
              }}
              text="CANCELAR"
              closeIcon
              black
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntHorDias;
